import React from 'react'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'

import { ObjectDebug } from 'components/Util/ObjectDebug'
import { DebugToolsContext } from './DebugTools'

const DebugObjects = ({ objectsInfoOrigin, objectsInfo }) => {
    return objectsInfo.map((info, i) => {
        return (
            <ObjectDebug
                key={i}
                title={`${objectsInfoOrigin} - ${info.title}`}
                object={info.object}
            />
        )
    })
}

const DebugToolsObjectView = () => {
    return (
        <DebugToolsContext.Consumer>
            {({ objectsInfo, objectsInfoOrigin }) => (
                objectsInfo && objectsInfo.length > 0 && (
                    <DebugObjects
                        objectsInfoOrigin={objectsInfoOrigin}
                        objectsInfo={objectsInfo}
                    />
                )
            )}
        </DebugToolsContext.Consumer>
    )
}

export default withErrorBoundaryNoRender(DebugToolsObjectView)
